import React from 'react';
import { Route } from 'react-router-dom';

import * as PATH from './path';
import OrderList from '../../domain/order/List/OrderList';
import OrderDetail from '../../domain/order/Detail/OrderDetail';
import VoucherOrderDetail from '../../domain/order/VoucherDetail/VoucherOrderDetail';
import Refund from '../../domain/order/Refund/Refund';
import AccountTemplate from '../../components/common/template/AccountTemplate';
import ItemResult from '../../domain/item/Result/ItemResult';
import FriendPayback from '../../domain/friend-payback/FriendPayback';
import VoucherCoupon from '../../components/common/organism/VoucherCoupon';
import PageTemplate from '../../components/common/template/PageTemplate';
import ReviewListTemplate from '../../components/common/template/ReviewListTemplate';
import WithDrawalPage from '../../pages/WithdrawalPage';

const MyPageRoutes = () => {
  return (
    <>
      <Route
        exact
        path={MYPAGE_COUPON_MENU.path}
        render={() => (
          <PageTemplate title={MYPAGE_COUPON_MENU.label}>
            <VoucherCoupon status="delegated" />
          </PageTemplate>
        )}
      />
      <Route
        exact
        path={MYPAGE_ORDER_MENU.path}
        render={() => (
          <PageTemplate title={MYPAGE_ORDER_MENU.label}>
            <OrderList />
          </PageTemplate>
        )}
      />
      <Route
        exact
        path={`${PATH.MYPAGE_ORDER_RESULT}/:id`}
        render={({ match }) => (
          <PageTemplate title="결과보기">
            <ItemResult id={match.params.id} />
          </PageTemplate>
        )}
      />
      <Route
        exact
        path={`${MYPAGE_ORDER_DETAIL_MENU.path}/:id`}
        render={({ match }) => (
          <PageTemplate title={MYPAGE_ORDER_DETAIL_MENU.label}>
            <OrderDetail id={match.params.id} />
          </PageTemplate>
        )}
      />
      <Route
        exact
        path={`${PATH.MYPAGE_VOUCHER_ORDER_DETAIL}/:id`}
        render={({ match }) => (
          <PageTemplate title={MYPAGE_ORDER_DETAIL_MENU.label}>
            <VoucherOrderDetail id={match.params.id} />
          </PageTemplate>
        )}
      />
      <Route
        exact
        path={`${PATH.MYPAGE_ORDER_REFUND}/:id`}
        render={({ match }) => (
          <PageTemplate title="주문취소">
            <Refund id={match.params.id} />
          </PageTemplate>
        )}
      />
      <Route
        exact
        path={ACCOUNT_MENU.path}
        render={() => (
          <PageTemplate title={ACCOUNT_MENU.label}>
            <AccountTemplate />
          </PageTemplate>
        )}
      />
      <Route
        exact
        path={PATH.MYPAGE_ACCOUNT_WITHDRAWAL}
        render={() => (
          <PageTemplate title={'회원탈퇴'}>
            <WithDrawalPage />
          </PageTemplate>
        )}
      />
      <Route
        exact
        path={MYPAGE_REVIEW_MENU.path}
        render={() => <ReviewListTemplate />}
      />
      <Route
        exact
        path={PAYBACK_MENU.path}
        render={() => (
          <PageTemplate title={PAYBACK_MENU.label} noMargin>
            <FriendPayback />
          </PageTemplate>
        )}
      />
    </>
  );
};

export default MyPageRoutes;

export const MYPAGE_ORDER_MENU = {
  label: '주문내역',
  path: PATH.MYPAGE_ORDER,
};

export const MYPAGE_REVIEW_MENU = {
  label: '리뷰관리',
  path: PATH.MYPAGE_REVIEW,
};

export const MYPAGE_COUPON_MENU = {
  label: '쿠폰함',
  path: PATH.MYPAGE_VOUCHER,
};

export const MYPAGE_PATH_LOGGED = [
  MYPAGE_ORDER_MENU,
  MYPAGE_REVIEW_MENU,
  MYPAGE_COUPON_MENU,
];

export const PAYBACK_MENU = {
  label: '친구추천코드',
  path: PATH.MYPAGE_PAYBACK,
};

export const ACCOUNT_MENU = {
  label: '계정관리',
  path: PATH.MYPAGE_ACCOUNT,
};

// voucher path 별도
export const MYPAGE_ORDER_DETAIL_MENU = {
  label: '주문상세',
  path: PATH.MYPAGE_ORDER_DETAIL,
};
